// Rep availability roster (approved HTML component: rep-availability).
// Filters reps by availability tab; selecting a row would open a rep
// detail dialog in the runtime. For this port the detail click fires
// the onOpenRep callback without opening a modal.
import type { ReactNode } from 'react';
import { useState } from 'react';
import type { RepStatus, TeamLiveRep } from '../mockData.js';

export interface RepAvailabilityProps {
  reps: TeamLiveRep[];
  snapshotTime: string;
  onOpenRep?: (rep: TeamLiveRep) => void;
}

const FILTERS: Array<{ key: 'all' | RepStatus; label: string }> = [
  { key: 'all', label: 'Everyone' },
  { key: 'available', label: 'Available' },
  { key: 'engaged', label: 'Engaged' },
  { key: 'break', label: 'On break' },
];

export function RepAvailability({
  reps,
  snapshotTime,
  onOpenRep,
}: RepAvailabilityProps): ReactNode {
  const [filter, setFilter] = useState<'all' | RepStatus>('all');
  const rows = filter === 'all' ? reps : reps.filter(r => r.status === filter);
  return (
    <section className="n-card" data-component="rep-availability">
      <div className="n-head">
        <h2>Team Live</h2>
        <small>Example snapshot · {snapshotTime}</small>
      </div>
      <div className="n-body" style={{ paddingBottom: 0 }}>
        <div className="n-tabs" id="team-filter" role="tablist">
          {FILTERS.map(f => (
            <button
              key={f.key}
              type="button"
              data-filter={f.key}
              aria-pressed={filter === f.key}
              onClick={() => setFilter(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>
      <table className="n-table">
        <thead>
          <tr>
            <th>Rep / status</th>
            <th>Current focus</th>
            <th>Today</th>
            <th>Open work</th>
            <th />
          </tr>
        </thead>
        <tbody id="team-rows">
          {rows.map(rep => (
            <tr key={rep.id}>
              <td>
                <strong>{rep.name}</strong>
                <small>{rep.statusLabel}</small>
              </td>
              <td>{rep.focus}</td>
              <td>{rep.creditedToday}</td>
              <td>{rep.openWork}</td>
              <td>
                <button
                  className="n-link"
                  type="button"
                  data-rep={rep.name}
                  onClick={() => onOpenRep?.(rep)}
                >
                  Details →
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
